
import { Component, Mixins } from 'vue-property-decorator';
import { VueClass } from 'vue-class-component/lib/declarations';
import { AxVuetify } from '@/mixins';

import * as V from 'vuetify/lib';

const Base = V.VRadioGroup as VueClass<unknown>;

@Component
export default class VRadioGroup extends Mixins(Base, AxVuetify) {
  created() {
    Object.defineProperty(this, 'depressed', {
      get: () => {
        return true;
      }
    });

    Object.defineProperty(this, 'classes', {
      get: () => {
        return {
          ...this.baseClasses
        };
      }
    });
  }
}
